import _ from "lodash";

/** equals by a list of fields */
export const isEqualBy =
    <T>(list: Array<keyof T>) =>
    (a: T, b: T) =>
        _.every(list, (key) => _.isEqual(a?.[key], b?.[key]));
